import {useState} from "react";
import Speaker from "../speakers/Speaker";
import {StatusIndicator} from "../StatusIndicator";
import {toggleStatus} from "../../hooks/useToggleSection";

const Session = ({session, speakers}) => {
	const [isToggled, setIsToggled]     = useState(false);
	const sessionSpeakers               = speakers.filter(speaker => speaker.sessions.includes(session.ID));
	const sessionDurationInMilliseconds = Math.abs(new Date(session.endTime) - new Date(session.startTime));
	const sessionDurationInMinutes      = Math.floor( sessionDurationInMilliseconds / 1000 / 60);
	const sessionDate                   = session.startTime.slice(0, session.startTime.indexOf(' ') + 1);
	const startTime                     = session.startTime.slice(session.startTime.indexOf(' '));
	const endTime                       = session.endTime.slice(session.startTime.indexOf(' '));

	const statusIndicatorShouldDisplay = () => {
		const sessionHasSpeakers = sessionSpeakers && sessionSpeakers.length > 0;
		const sessionHasDescription = session.description && session.description.length > 0;
		return sessionHasDescription || sessionHasSpeakers
	}

	const MaybeShowSpeakers = () => {
		if (sessionSpeakers.length === 0 || !isToggled) {
			return null
		}

		return sessionSpeakers.map(speaker => {
			return <Speaker key={`${session.ID}-${speaker.ID}`} speaker={speaker} showToggle={false} />
		})
	}

	return (
			<article className={'event-info-item'} data-session-id={session.ID} key={session.ID} onClick={() => toggleStatus(setIsToggled, isToggled)}>
				<div className={'event-info-header'}>
					<h2>{session.title}</h2>

					<StatusIndicator isActive={isToggled} show={statusIndicatorShouldDisplay()}/>

					<p>{sessionDate} | {startTime} - {endTime}, {sessionDurationInMinutes} MIN</p>
				</div>

				{
					isToggled && <p>{session.description}</p>
				}

				<section className={'session-speakers event-info-list'}>
					<MaybeShowSpeakers />
				</section>
			</article>
	)
}

export default Session;
